import { useEffect } from "react";

import { useTranslation } from "react-i18next";

import { useGetProfileQuery } from "@/queries/hooks/profileHooks";

import { LANG_STORAGE_KEY, SUPPORTED_LANGUAGES } from "./index";

/**
 * Syncs the authenticated user's `preferred_language` from the backend
 * profile into i18next on each profile fetch. Idempotent.
 */
export function useLanguageSync() {
  const { i18n } = useTranslation();
  const { data } = useGetProfileQuery();

  const serverLang = data?.profile.preferred_language;

  useEffect(() => {
    if (!serverLang) return;
    if (!SUPPORTED_LANGUAGES.includes(serverLang)) return;
    if (i18n.language === serverLang) return;
    void i18n.changeLanguage(serverLang);
    try {
      localStorage.setItem(LANG_STORAGE_KEY, serverLang);
    } catch {
      // ignore; localStorage may be unavailable
    }
  }, [serverLang, i18n]);
}
